module.exports = __webpack_public_path__ + "static/media/education fee.8bb2790d.png";